var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 80C34.4667 80 29.2667 78.95 24.4 76.85C19.5333 74.75 15.3 71.9 11.7 68.3C8.1 64.7 5.25 60.4667 3.15 55.6C1.05 50.7333 0 45.5333 0 40C0 34.4667 1.05 29.2667 3.15 24.4C5.25 19.5333 8.1 15.3 11.7 11.7C15.3 8.1 19.5333 5.25 24.4 3.15C29.2667 1.05 34.4667 0 40 0C45.5333 0 50.7333 1.05 55.6 3.15C60.4667 5.25 64.7 8.1 68.3 11.7C71.9 15.3 74.75 19.5333 76.85 24.4C78.95 29.2667 80 34.4667 80 40C80 45.5333 78.95 50.7333 76.85 55.6C74.75 60.4667 71.9 64.7 68.3 68.3C64.7 71.9 60.4667 74.75 55.6 76.85C50.7333 78.95 45.5333 80 40 80ZM40 72C48.9333 72 56.5 68.9 62.7 62.7C68.9 56.5 72 48.9333 72 40H40V8C31.0667 8 23.5 11.1 17.3 17.3C11.1 23.5 8 31.0667 8 40C8 48.9333 11.1 56.5 17.3 62.7C23.5 68.9 31.0667 72 40 72Z",
    fill: "#0A71CE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.fd663b8db66a8a4ad65cac57b09b9d5d.svg";
export { ForwardRef as ReactComponent };